/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_TitleInputs */

const en_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const ko_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개인정보처리방침`)
};

const ja_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライバシーポリシー`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Privacy_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_title = /** @type {((inputs?: Privacy_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_title(inputs)
	if (locale === "ko") return ko_privacy_title(inputs)
	return ja_privacy_title(inputs)
});